/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button[_ngcontent-%COMP%]{background-color:rgba(11,30,199,.568);border:none;color:#fff;padding:15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:0;cursor:pointer;position:relative;top:50%;left:40%}\n/*# sourceMappingURL=prevdue-dialog.component.css.map*/"];
export { styles as styles };
